import {
  ZOOM_CHANGE_TYPE,
  type ZoomChangeType,
  type ZoomInZoomOut,
} from '../../../types/zoom.js';
import { ZOOM_FACTOR } from '../../interactions-overlay/constants.js';

export function useTriggerZoom(
  width: number,
  applyZoomDelta: (
    deltaStart: number,
    deltaEnd: number,
    type: ZoomChangeType,
  ) => void,
) {
  return (type: ZoomInZoomOut) => {
    const modifier = type === ZOOM_CHANGE_TYPE.ZoomIn ? 1 : -1;
    const delta = Math.floor((width * ZOOM_FACTOR) / 2) * modifier;

    applyZoomDelta(delta, -delta, type);
  };
}
